import moment from 'moment';

import { isNumber, isRequiredFieldTrueInObject } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (isNumber(values.cutoffPeriod, true)) {
    errors.cutoffPeriod = 'Cutoff period can be only number';
  }

  // if (isRequiredFieldTrueInObject(values.days || '', true)) {
  //   errors.days = 'Select days is required';
  // }

  if (values.daysArray && values.daysArray.length) {
    const daysArrayErrors = [];

    values.daysArray.forEach((day, dayIndex) => {
      const daysErrors = {};

      if (isRequiredFieldTrueInObject(day.days || '', true)) {
        daysErrors.days = 'Select days is required';
        daysArrayErrors[dayIndex] = daysErrors;
      }

      if (day.startTimeAndDuration && day.startTimeAndDuration.length) {
        const timeArrayErrors = [];

        const startTimeAndDurationFormatted = day.startTimeAndDuration.map(
          item => ({
            ...item,
            startTime: moment(item.startTime).format('HH:mm'),
            duration: parseInt(item.duration)
          })
        );

        day.startTimeAndDuration.forEach((time, timeIndex) => {
          const timeErrors = {};
          if (isNumber(time.duration, true)) {
            timeErrors.duration = 'Duration is required';
            timeArrayErrors[timeIndex] = timeErrors;
          }

          const duplicatedItems = startTimeAndDurationFormatted.filter(
            item =>
              item.startTime === moment(time.startTime).format('HH:mm') &&
              item.duration === parseInt(time.duration) &&
              item.timeType === time.timeType
          );

          if (duplicatedItems.length > 1) {
            timeErrors.startTime = 'Error';
            timeErrors.duration = 'Error';
            timeErrors.timeType = 'Error';
            timeArrayErrors[timeIndex] = timeErrors;
            timeArrayErrors['_error'] = {
              ...timeArrayErrors['_error'],
              [timeIndex]: 'This start time and duration already exists'
            };
          }
        });

        if (timeArrayErrors.length || timeArrayErrors['_error']) {
          daysErrors.startTimeAndDuration = timeArrayErrors;
          daysArrayErrors[dayIndex] = daysErrors;
        }
      }
    });

    if (daysArrayErrors.length) {
      errors.daysArray = daysArrayErrors;
      errors.daysArray = { ...daysArrayErrors, _error: { ...daysArrayErrors } };
    }
  }

  return errors;
};

export default validate;
